import React from 'react';

function getInitials(user) {
	if (!user) return '?';
	const first = user.first?.[0] || '';
	const last = user.last?.[0] || '';
	if (first || last) return `${first}${last}`.toUpperCase();
	if (user.email) return user.email[0].toUpperCase();
	return '?';
}

function UserAvatar({ user, size = 32, className = '' }) {
	const initials = getInitials(user);
	return (
		<div
			className={`rounded-full bg-[#880e4f] text-white flex items-center justify-center font-semibold flex-shrink-0 ${className}`}
			style={{ width: size, height: size, fontSize: Math.max(10, size * 0.38) }}
			title={user?.email || 'Account'}
		>
			{initials}
		</div>
	);
}

export default UserAvatar;
